import React from "react";
import { Text, StyleSheet, View } from "react-native";

export const MotivationToast = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>✊ Motivation sent to friends</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  title: { fontSize: 22, fontWeight: "700" },
});
